import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { UpdateSuccessfullyIcon } from '../components/icons/UpdateSuccessfullyIcon.jsx';
import {
  retrieveOrgStructureUploadStatus,
  selectRetrieveUploadStatusState,
} from '../modules/organizations.js';
import { selectCurrentOrganizationId } from '../modules/auth.js';
import { LoaderIcon } from '../components/icons/LoaderIcon.jsx';

const mapStateToProps = (state) => ({
  organizationId: selectCurrentOrganizationId(state),
  uploadStatus: selectRetrieveUploadStatusState(state).orgStructureUploadStatus,
});

const mapDispatchToProps = { retrieveOrgStructureUploadStatus };

const UpdateProgressBannerContainer = ({
  retrieveOrgStructureUploadStatus,
  uploadStatus,
  organizationId,
  logo,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    organizationId && retrieveOrgStructureUploadStatus(organizationId);
  }, []);

  useEffect(() => {
    let timeout = null;

    if (uploadStatus && uploadStatus.status === 'processing') {
      setShow(true);
      timeout = setTimeout(
        () => retrieveOrgStructureUploadStatus(organizationId),
        20000
      );
    } else if (!uploadStatus || uploadStatus.status === 'completed') {
      clearTimeout(timeout);
    }

    return () => clearTimeout(timeout);
  }, [uploadStatus]);

  if (!uploadStatus) return null;
  if (!show) return null;

  return (
    <div className="banner">
      <div className="component component-border-bottom w-100 m-b-16">
        {logo}
      </div>
      {uploadStatus.status === 'processing' ? (
        <div className="flex flex-col flex-align-center content">
          <div className="icon animated m-b-24">
            <LoaderIcon />
          </div>
          <h4 className="m-b-24">
            Organizational Structure Update in Progress
          </h4>
          <div className="text-center text-muted">
            We are currently processing the new organizational structure <br />
            and updating all related objects in the system. <br />
            Some areas may be unavailable for a couple of minutes during
            <br /> this process.
          </div>
        </div>
      ) : (
        <div className="flex flex-col flex-align-center content">
          <div className="icon m-b-24">
            <UpdateSuccessfullyIcon />
          </div>
          <h4 className="m-b-24">Update Successfully Completed</h4>
          <div className="text-center text-muted m-b-30">
            Participant updates for organization structure and all related{' '}
            <br /> pages where organizational structure is used were <br />{' '}
            successfully completed. Please refresh the page to see the <br />{' '}
            latest changes.
          </div>
          <div style={{ padding: '0 30px' }}>
            <Button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateProgressBannerContainer);
